export default "/images/fed2451178e44de87708617a1f8d89eb.avif";